import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TreeViewPlaceholderStyleConstantType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getTreeViewRowIndent
} from "../row/stylesheet";

const stylesheet = StyleSheet.create({
    row: {
        flexDirection: "row",
        alignItems: "center"
    }
});

export const useStyles = ({
    measures,
    level
}: TreeViewPlaceholderStyleConstantType) => {
    const styles = {
        row: {
            paddingStart: getTreeViewRowIndent({
                measures,
                level
            }) + measures.slotWidth + measures.gap,
            paddingEnd: measures.paddingEnd,
            minHeight: measures.rowHeight,
            gap: measures.gap
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
